<script>
export default {
  name: "ProductGiftvoucherForm",
  props: ['product'],
  data(){
    return{
      giftvoucher: false
    }

  },
  mounted() {
    this.giftvoucher = this.product.is_gift_voucher === true || this.product.is_gift_voucher === '1'

  }
}
</script>

<template>
  <li class="boolean input optional">
    <input type="hidden" name="product[is_gift_voucher]"
           value="0"
           autocomplete="off">
    <label for="product_giftvoucher" class=""><input type="checkbox" name="product[is_gift_voucher]"
                                                            id="product_giftvoucher" value="1" v-model="giftvoucher" /> Je to dárkový poukaz    </label>

      <div v-if="giftvoucher" style="margin-top: 15px; border: 1px solid #ccc; padding: 10px; background-color: #f9f9f9;">
        <label>Šablona dárkového poukazu (PDF)</label>
        <input type="file" name="gift_voucher_template" />
        <span> {{product.gift_voucher_template}} </span>

        <div class="row">
          <div class="col-md-4">
            <div>
              <label>Hodnota poukazu</label>
              <input type="number" name="product[gift_voucher_value]" class="form-control " v-model="product.gift_voucher_value" size="8" />
            </div>

          </div>

          <div class="col-md-4">
            <label>Prefix kódu poukazu</label>
            <input type="text" name="product[voucher_prefix]" class="form-control " v-model="product.voucher_prefix" size="8" />
            <i class="help">např. DARMJ</i>
          </div>


          <div class="col-md-4">
            <label>Počet poukazů při objednání</label>
            <input type="number" name="product[voucher_quantity]" class="form-control " v-model="product.voucher_quantity" size="8" />
            <i class="help"> např. 2 pro kace 1+1</i>
          </div>
        </div>

        <div class="row" style="margin-top: 10px;">
          <div class="col-md-12">
            <input type="hidden" name="product[multipurpose_voucher]" value="0" autocomplete="off">
            <label>
              <input type="checkbox"
                     name="product[multipurpose_voucher]"
                     value="1"
                     :checked="product.multipurpose_voucher == true || product.multipurpose_voucher == '1'" />
              Víceúčelový poukaz
            </label>
            <i class="help" style="display:block;">Zaškrtněte pokud jde o víceúčelový dárkový poukaz (DPH 0 % při nákupu, zdanění při uplatnění). Objednávky s tímto poukazem se nezahrnou do běžného účetního reportu.</i>
          </div>
        </div>
      </div>
  </li>
</template>

<style scoped>
.help {
  font-size: 0.9em;
  color: #666;
}

</style>